import React from 'react';
import ReactDOM from 'react-dom';

import RenderPopup from './popup.renderer';

const Popup = () =>
  ReactDOM.createPortal(<RenderPopup />, document.getElementById('root'));

export default Popup;
